export function fetchPlayables(state, { page, sort, filter }) {
  return {
    ...state,
    playables: {
      ...state.playables,
      currentPage: page,
      sort: sort || state.playables.sort,
      filter: filter || state.playables.filter,
    },
  };
}

export function fetchPlayablesSuccess(state, playables) {
  return {
    ...state,
    playables: {
      ...state.playables,
      numberOfPages: playables.numberOfPages,
      count: playables.count,
      items: playables.items,
    },
  };
}

export function openUpdatePlayable(state, { playable }) {
  return {
    ...state,
    editPlayable: {
      playable,
      showModal: true,
      addingErrorMessage: '',
    },
  };
}

export function closeUpdatePlayable(state) {
  return {
    ...state,
    editPlayable: {
      showModal: false,
      addingErrorMessage: '',
    },
  };
}

export function addPlayableSuccess(state, playable) {
  const sortFunc = (p1, p2) =>
  (p1[state.playables.sort.key] > p2[state.playables.sort.key] ? 1 : -1)
  * state.playables.sort.order;

  return {
    ...state,
    playables: {
      ...state.playables,
      items: [
        ...state.playables.items,
        playable,
      ].sort(sortFunc),
    },
  };
}

export function addPlayableFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';

  return {
    ...state,
    editPlayable: {
      ...state.editPlayable,
      addingErrorMessage: errorMessage,
    },
  };
}

export function updatePlayableSuccess(state, { playableId, playable: playableData }) {
  const playableIndex = state.playables.items.findIndex(x => x._id === playableId);
  const playable = state.playables.items.find(x => x._id === playableId);
  if (!playable) {
    return state;
  }

  const sortFunc = (p1, p2) =>
  (p1[state.playables.sort.key] > p2[state.playables.sort.key] ? 1 : -1)
  * state.playables.sort.order;

  return {
    ...state,
    playables: {
      ...state.playables,
      items: [
        ...state.playables.items.slice(0, playableIndex),
        {
          ...playable,
          ...playableData,
        },
        ...state.playables.items.slice(playableIndex + 1),
      ].sort(sortFunc),
    },
  };
}

export function updatePlayableFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';

  return {
    ...state,
    editPlayable: {
      ...state.editPlayable,
      addingErrorMessage: errorMessage,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/playables.js
 **/